import "../src/login.css";
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function Logout()
 {


    const [TokenStatus, setTokenStatus] = useState();
    localStorage.clear('prc_token');
    localStorage.clear('prc_ldap_first_name');
    localStorage.clear('prc_ldap_last_name');
    localStorage.clear('prc_ldap_username');
    //setTokenStatus("401");
    localStorage.clear('token');
    return(
<div id="content" style={{ height: "100%",backgroundImage: "url('https://intranet-backend.procuratio.com/img/bg_pcr.jpg')",
    backgroundSize: "cover",
    backgroundrepeat: "no-repeat", }}>
    <div id="loginBox">

        <span id="logo" >Bitte schließen Sie jetzt das Browserfenster</span>
      
    </div>
</div>)}